/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContactSearchResult } from './APIContactSearchResult';
import {
    APIContactSearchResultFromJSON,
    APIContactSearchResultFromJSONTyped,
    APIContactSearchResultToJSON,
} from './APIContactSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIContactSearchResponse
 */
export interface APIContactSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIContactSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIContactSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIContactSearchResult>}
     * @memberof APIContactSearchResponse
     */
    results: Array<APIContactSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIContactSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIContactSearchResponse interface.
 */
export function instanceOfAPIContactSearchResponse(value: object): value is APIContactSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIContactSearchResponseFromJSON(json: any): APIContactSearchResponse {
    return APIContactSearchResponseFromJSONTyped(json, false);
}

export function APIContactSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIContactSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIContactSearchResponseToJSON(value?: APIContactSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIContactSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

